import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { url } from '@datacamp/exercise-library-utils';
import { getEndpoints } from '../lib/endpoints';
export class AiApiClient {
  constructor(endpoint) {
    this.endpoint = endpoint;
    _defineProperty(this, "generatePrediction", _ref => {
      let {
        body,
        params
      } = _ref;
      return fetch(url(this.endpoint, '/learn/v1/prediction/generate', params.modelTag), {
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
    });
    _defineProperty(this, "saveScore", _ref2 => {
      let {
        body,
        params
      } = _ref2;
      return fetch(url(this.endpoint, '/learn/v1/prediction', params.predictionId.toString(10), 'score'), {
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
    });
    _defineProperty(this, "generateValidation", _ref3 => {
      let {
        body,
        params
      } = _ref3;
      return fetch(url(this.endpoint, '/learn/v1/validation/generate', params.modelTag), {
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
    });
    _defineProperty(this, "generateConversationPrediction", _ref4 => {
      let {
        body,
        params
      } = _ref4;
      return fetch(url(this.endpoint, '/learn/v1/conversation/generate', params.modelTag), {
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
    });
  }
}
export const getAiApiClient = environment => new AiApiClient(getEndpoints(environment).AI_API);